import { faBan, faEdit, faPlus, faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useState } from "react"
import { Button, Col, Form, Modal, Row } from "react-bootstrap"

export interface EditionModalState {
  mode: "add" | "rename" | "delete" | null
  type: "goal" | "asset"
  currentName: string
  onConfirm: (name?: string) => Promise<void>
}

interface EditionModalProps extends EditionModalState {
  onHide: () => void
}

export const EditionModal = ({ mode, type, currentName, onConfirm, onHide }: EditionModalProps) => {
  const [newName, setNewName] = useState<string>(currentName || "")
  const [loading, setLoading] = useState<boolean>(false)

  const executeSave = async () => {
    setLoading(true)
    try {
      await onConfirm(newName)
      setNewName("")
      setLoading(false)
    } catch (e) {
      console.error(e)
    } finally {
      setLoading(false)
    }
  }

  return <Modal show={!!mode} onHide={onHide}>
    <Modal.Header closeButton={!loading}>
      <Modal.Title>{mode === "add" ? "Add" : mode === "rename" ? "Rename" : "Delete"} {type === "goal" ? "goal" : "asset"}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {mode === "delete" ? <p>Are you sure you want to delete {type === "goal" ? "goal" : "asset"} "{currentName}"?</p> :
        <Form onSubmit={(e) => { e.preventDefault(); executeSave() }}>
          <Form.Group as={Row} className="mb-3" controlId="modal-name">
            <Form.Label column sm="2">Name</Form.Label>
            <Col sm="10">
              <Form.Control type="text" autoFocus onFocus={(e) => e.target.select()} defaultValue={currentName} onChange={(e) => setNewName(e.target.value)} />
            </Col>
          </Form.Group>
        </Form>
      }
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onHide} disabled={loading}><FontAwesomeIcon icon={faBan} /> Cancel</Button>
      {mode === "delete" && (loading ? <Button variant="danger" disabled={true}><FontAwesomeIcon icon={faSpinner} spin /> Deleting...</Button> : <Button variant="danger" onClick={() => executeSave()}><FontAwesomeIcon icon={faTrash} /> Delete</Button>)}
      {mode === "add" && (loading ? <Button variant="success" disabled={true}><FontAwesomeIcon icon={faSpinner} spin /> Adding...</Button> : <Button variant="success" onClick={() => executeSave()} disabled={newName.trim().length === 0}><FontAwesomeIcon icon={faPlus} /> Add</Button>)}
      {mode === "rename" && (loading ? <Button variant="primary" disabled={true}><FontAwesomeIcon icon={faSpinner} spin /> Renaming...</Button> : <Button variant="primary" onClick={() => executeSave()} disabled={newName.trim().length === 0}><FontAwesomeIcon icon={faEdit} /> Rename</Button>)}
    </Modal.Footer>
  </Modal>
}
